import React from 'react';
import * as ReactDOM from 'react-dom';
import LearningCenterSearch from './pages/learning-center-search'; // Adjust the path as needed

// Make sure your target div exists in the HTML, e.g. <div id="learning-center-search"></div>
const target = document.getElementById('learning-center-search');
const placeholder = target?.getAttribute('searchPlaceholder');
if (target) {
  ReactDOM.render(<LearningCenterSearch searchPlaceholder={placeholder} />,target);
}